import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { AppState } from '../../../../state/createStore';
import { setErrorVisibility } from '../../../../state/addressInformationForm/addressForm.actions';
import DispatchTimeSelector from './DispatchTimeSelector';
import { selectOrderPacingLevel } from '../../../../state/selectors/orderPacingSelector';
import { supportedDispatchTypesSelectorV2 } from '../../../../state/selectors/supportedDispatchTypesSelector';

function mapStateToProps(state: AppState, ownProps: any) {
  return {
    isMl: state.session.isMultiLocation,
    address: ownProps.address || state.addressForm.selectedAddressOption,
    supportedDispatchTypesV2: supportedDispatchTypesSelectorV2(state),
    orderPacingLevel: selectOrderPacingLevel(state),
    dispatchTimeCache: state.checkout.dispatchTimeCache,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      setErrorVisibility,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DispatchTimeSelector);
